/* istanbul ignore file */
import * as types from '../constants';
import { getUpdatedQuoteList } from '../../../utils';
import { assignIn, isEmpty, filter, find } from 'lodash';
import { CYBER_DEFAULT_PLAN } from '../../../constants';
import { CommonQuote } from '../../../quote-application/utils/types';

export interface UpcomingCarriersListType {
  carrierId: string;
  carrierName: string;
  carrierLogo: string;
  agentUrl?: string;
  statusText?: string;
  purchaseType?: string;
  isActive?: boolean;
  isAvailableForQuoting?: boolean;
}

export interface CyberSecurityState {
  quoteStatus: string;
  quoteList: Array<CommonQuote>;
  quoteErrorList: Array<any>;
  quoteListLoader: boolean;
  quotingCarriers: Array<any>;
  herdId: string;
  quotingDetails: any;
  pollingDetails: any;
  noQuoteAvailable: boolean;
  quotesLoaded: boolean;
  bridgeToCarrierLoader: boolean;
  isQuoteRefresh: boolean;
  upcomingCarrierList: Array<UpcomingCarriersListType>;
}

const INIT_CYBER_SECURITY_STATE: CyberSecurityState = {
  quoteList: [],
  quoteErrorList: [],
  quoteListLoader: false,
  quotingCarriers: [],
  herdId: '',
  quotingDetails: null,
  pollingDetails: null,
  noQuoteAvailable: false,
  quotesLoaded: false,
  bridgeToCarrierLoader: false,
  isQuoteRefresh: false,
  upcomingCarrierList: [],
  quoteStatus: '',
};

const INIT_STATE = { ...INIT_CYBER_SECURITY_STATE };

export default (state = INIT_STATE, action: AppRedux.Action): CyberSecurityState => {
  switch (action.type) {
    case types.APP_INIT: {
      return {
        ...state,
        quoteListLoader: false,
      };
    }

    case types.SET_CYBER_SECURITY_QUOTES_DETAILS: {
      const { quoteList, herdId, quoteErrorList } = action.payload;
      return {
        ...state,
        quoteList: quoteList,
        quoteErrorList: quoteErrorList,
        herdId: herdId ? herdId : state.herdId,
      };
    }

    case types.CYBER_SECURITY_DETAILS_LOADER: {
      return {
        ...state,
        quoteListLoader: action.payload,
      };
    }

    case types.STORE_CYBER_SECURITY_QUOTE_LIST: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case types.CLEAR_CYBER_SECURITY_STATE: {
      return {
        ...state,
        ...INIT_STATE,
      };
    }

    case types.UPDATE_CYBER_SECURITY_QUOTE_DETAILS: {
      return {
        ...state,
        quotingDetails: {
          ...action.payload,
        },
      };
    }

    case types.SET_CYBER_SECURITY_POLLING_ERROR_DETAILS: {
      let oldQuoteErrorList = getUpdatedQuoteList(state, action.payload);
      if (oldQuoteErrorList) {
        oldQuoteErrorList = filter(oldQuoteErrorList, (error: any) =>
          assignIn(error, { quoteError: true })
        );
      }
      return {
        ...state,
        quoteErrorList: [...oldQuoteErrorList],
        pollingDetails: {
          ...action.payload,
        },
      };
    }

    case types.SET_CYBER_SECURITY_POLLING_DETAILS: {
      const { quotes, error_details } = action.payload;
      let oldQuotesList = [...state.quoteList];
      let quoteErrorList = [...state.quoteErrorList];
      if (!isEmpty(action.payload.quotes)) {
        filter(quotes, quote => {
          return assignIn(quote, {
            premiumDetails: quote[CYBER_DEFAULT_PLAN],
            selectedPlan: CYBER_DEFAULT_PLAN,
          });
        });
        let newQuoteErrorList: Array<any> = [];
        newQuoteErrorList = filter(
          quotes,
          quote =>
            !find(oldQuotesList, {
              carrier_id: quote.carrier_id,
              name: quote.name,
            }) && !find(oldQuotesList, { carrier_id: quote.carrier_id })
        );
        oldQuotesList = [...oldQuotesList, ...newQuoteErrorList];
      }
      if (error_details && error_details.display_errors_on_ui) {
        quoteErrorList = filter(error_details.errors, error =>
          assignIn(error, { quoteError: true })
        );
      }
      return {
        ...state,
        quoteList: [...oldQuotesList],
        quoteErrorList,
        pollingDetails: {
          ...action.payload,
        },
      };
    }

    case types.CYBER_BRIDGE_TO_CARRIER_LOADER: {
      const { carrier_id, loader } = action.payload;
      let cyberQuoteList = [...state.quoteList];
      const updateIndex = cyberQuoteList.findIndex((item: any) => item.carrier_id === carrier_id);
      if (updateIndex !== -1) {
        cyberQuoteList[updateIndex] = {
          ...cyberQuoteList[updateIndex],
          bridgeToCarrierLoader: loader,
        };
      }
      return {
        ...state,
        bridgeToCarrierLoader: loader,
        quoteList: cyberQuoteList,
      };
    }

    default:
      return state;
  }
};
